export const API_URL = process.env.REACT_APP_API_PATH;

export const API_PATH = API_URL + 'api';

export const API = {
  registerUser: `${API_PATH}/users`,
  registerDraw: `${API_PATH}/draws`,
  resendEmail: `${API_PATH}/resend`,
};

export const routes = {
  home: '/',
  thankyou: '/thank-you',
  results: '/results/:token'
};

export const EMAIL_USERNAME_PATTERN = /^[a-z0-9]+(?:[._][a-z0-9]+)*(?:\+[0-9]+)*$/;
export const EMAIL_DOMAIN_PATTERN = /^([a-z0-9]+?(-[a-z0-9]+)*(?:[a-z0-9]*[a-z0-9])?\.)+[a-z0-9]+$/;

export const prices = {
  1: {
    id: 1,
    name: '1 VEGETARIAN LOADED NACHOS',
    message: 'A plate of Vegetarian Loaded Nachos',
    limit: 50
  },
  2: {
    id: 2,
    name: '1 PINT NEON DONKEY PILSNER',
    message: 'A pint of Neon Donkey Pilsner',
    limit: 70
  },
  3: {
    id: 3,
    name: '$10 OFF YOUR BILL',
    message: 'A $10 off your bill',
    limit: 80
  },
  4: {
    id: 4,
    name: '1 PINT NEON DONKEY OATMEAL STOUT',
    message: 'A pint of Neon Donkey Oatmeal Stout',
    limit: 70
  },
  5: {
    id: 5,
    name: '10% OFF YOUR BILL',
    message: 'A 10% off your bill',
    limit: 300
  },
  6: {
    id: 6,
    name: '1 GLASS OF MARGARITA',
    message: 'A glass of Margarita',
    limit: 50
  },
  7: {
    id: 7,
    name: '1 ANCHO BEEF LOADED NACHOS',
    message: 'An Ancho Beef Loaded Nachos',
    limit: 50
  },
  8: {
    id: 8,
    name: '1 PINT NEON DONKEY GOLDEN ALE',
    message: 'A pint of Neon Donkey Golden Ale',
    limit: 70
  },
  9: {
    id: 9,
    name: '$5 OFF YOUR FOOD BILL',
    message: 'A $5 off your food bill',
    limit: 300
  },
  10: {
    id: 10,
    name: '1 PINT NEON DONKEY IPA',
    message: 'A pint of Neon Donkey IPA',
    limit: 70
  },
  11: {
    id: 11,
    name: '2 FOR 1 TACOS OF YOUR CHOICE',
    message: 'A 2 for 1 Tacos of your choice',
    limit: 50
  },
  12: {
    id: 12,
    name: '365 MARGARITAS IN 365 DAYS',
    message: 'The Grand Prize of recieving 365 Margaritas in 365 Days',
    limit: 1
  },
};
